module.exports = __webpack_public_path__ + "static/media/first_page_white_24dp.83b9921d.svg";